<div class="main-wrapper">
  <app-header> </app-header>
  <div class="page page-margin-top">
    <div class="container">
      @if (!isIframe) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
  <app-footer></app-footer>
</div>
